/* Polite Society product page — variant selection, qty, tabs, gallery dots, size guide drawer, recently viewed */
(function () {
  function money(cents) {
    var fmt = (window.theme && window.theme.moneyFormat) || '{{amount}}';
    var n = (cents / 100).toFixed(2);
    var parts = n.split('.');
    var withCommas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/<[^>]+>/g, '')
      .replace(/\{\{\s*amount\s*\}\}/, withCommas + '.' + parts[1])
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, withCommas)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1]);
  }

  function init(root) {
    if (root.dataset.psBound) return;
    root.dataset.psBound = '1';
    var variants = [];
    try { variants = JSON.parse(root.querySelector('[data-ps-variants]').textContent); } catch (e) {}
    var form = root.querySelector('form[data-type="add-to-cart-form"]');
    var idInput = root.querySelector('[data-ps-variant-id]');
    var priceEl = root.querySelector('[data-ps-price]');
    var atc = root.querySelector('[data-ps-atc]');
    var atcLabel = root.querySelector('[data-ps-atc-label]');
    var buyNow = root.querySelector('[data-ps-buy-now]');
    var colourName = root.querySelector('[data-ps-colour-name]');
    var options = root.querySelectorAll('[data-ps-option]');
    var strings = { add: atcLabel ? atcLabel.textContent.trim() : 'Add to cart', soldOut: (window.variantStrings && window.variantStrings.soldOut) || 'Sold out', unavailable: (window.variantStrings && window.variantStrings.unavailable) || 'Unavailable' };
    if (atc && atc.disabled) strings.add = (window.variantStrings && window.variantStrings.addToCart) || 'Add to cart';

    function selected() {
      var vals = [];
      options.forEach(function (o) { var c = o.querySelector('input:checked'); vals.push(c ? c.value : null); });
      return vals;
    }
    function findVariant(vals) {
      return variants.find(function (v) { return vals.every(function (val, i) { return val === null || v.options[i] === val; }); });
    }
    function markAvailability() {
      // strike-through size values that have no available variant given the other selections
      var vals = selected();
      options.forEach(function (o, idx) {
        o.querySelectorAll('input').forEach(function (input) {
          var test = vals.slice(); test[idx] = input.value;
          var match = variants.find(function (v) { return test.every(function (val, i) { return val === null || v.options[i] === val; }); });
          var label = input.nextElementSibling;
          if (label) label.classList.toggle('is-unavailable', !(match && match.available));
        });
      });
    }
    /* product-form.js signals an add-to-cart error by hiding the label, revealing
       .sold-out-message and setting aria-disabled — none of which it ever clears.
       Reset it here so a variant change brings the button back. */
    function clearErrorState() {
      if (!atc) return;
      atc.removeAttribute('aria-disabled');
      if (atcLabel) atcLabel.classList.remove('hidden');
      var sold = atc.querySelector('.sold-out-message');
      if (sold) sold.classList.add('hidden');
      showError('');
    }
    function update(push) {
      var vals = selected();
      var v = findVariant(vals);
      clearErrorState();
      /* before the no-variant bail-out: picking a colour whose current size doesn't exist
         still has to regroup the gallery */
      applyGrouping();
      if (colourName) {
        var colourFs = root.querySelector('.ps-pdp__option--colour input:checked');
        if (colourFs) colourName.textContent = colourFs.value;
      }
      if (!v) {
        if (atc) { atc.disabled = true; if (atcLabel) atcLabel.textContent = strings.unavailable; }
        if (buyNow) buyNow.disabled = true;
        markAvailability();
        return;
      }
      if (idInput) idInput.value = v.id;
      if (priceEl) {
        priceEl.innerHTML = (v.compare_at_price && v.compare_at_price > v.price ? '<s class="ps-pdp__compare">' + money(v.compare_at_price) + '</s> ' : '') + '<span data-ps-price-current>' + money(v.price) + '</span>';
      }
      if (atc) { atc.disabled = !v.available; if (atcLabel) atcLabel.textContent = v.available ? strings.add : strings.soldOut; }
      if (buyNow) buyNow.disabled = !v.available;
      if (v.featured_media && v.featured_media.id) scrollToMedia(v.featured_media.id);
      if (push && window.history.replaceState) {
        var url = new URL(window.location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url.toString());
      }
      markAvailability();
      root.dispatchEvent(new CustomEvent('ps:variant', { detail: v, bubbles: true }));
    }
    options.forEach(function (o) { o.addEventListener('change', function () { update(true); }); });
    markAvailability();

    /* ---------- gallery ---------- */
    var track = root.querySelector('[data-ps-gallery-track]');
    var dots = root.querySelectorAll('.ps-pdp__dot');
    function scrollToMedia(id) {
      var el = track && track.querySelector('[data-media-id="' + id + '"]');
      /* the variant's own image can be filtered out by colour grouping — fall back to
         the first image actually on screen rather than scrolling to a hidden element */
      if (el && el.hidden) el = track.querySelector('.ps-pdp__media:not([hidden])');
      if (!el) return;
      if (window.matchMedia('(min-width: 1100px)').matches) {
        var top = el.getBoundingClientRect().top + window.scrollY - (parseInt(getComputedStyle(document.documentElement).getPropertyValue('--ps-header-h')) || 95);
        window.scrollTo({ top: top, behavior: 'smooth' });
      } else {
        track.scrollTo({ left: el.offsetLeft, behavior: 'smooth' });
      }
    }
    if (track && dots.length) {
      track.addEventListener('scroll', function () {
        var visible = [].slice.call(dots).filter(function (d) { return !d.hidden; });
        var i = Math.round(track.scrollLeft / track.clientWidth);
        visible.forEach(function (d, j) { d.classList.toggle('is-active', j === i); });
      }, { passive: true });
    }

    /* ---------- gallery: group media by colour ----------
       Liquid can only see one media per variant (variant.featured_media) and seeds
       data-media-colour with it. The full mapping lives in /products/<handle>.json, whose
       images carry variant_ids — fetched once, then merged over the seed. */
    var groupOn = root.hasAttribute('data-ps-media-group');
    var sharedMode = root.dataset.psMediaShared || 'after';
    var colourIndex = parseInt(root.dataset.psColourIndex, 10);
    var mediaEls = track ? [].slice.call(track.querySelectorAll('.ps-pdp__media')) : [];

    /* A media group is a contiguous run in product order: the run starts at the colour's
       featured media (the only one Liquid can see, and the only one the product JSON ever
       tags) and continues until the next colour's run starts. So spread each seed forward
       over the media that follow it. Sorting by data-media-pos rather than reading the DOM,
       because the deep-linked media is hoisted to the front of the track. */
    function orderedMedia() {
      return mediaEls.slice().sort(function (a, b) {
        return (parseInt(a.dataset.mediaPos, 10) || 0) - (parseInt(b.dataset.mediaPos, 10) || 0);
      });
    }
    function colourList() {
      if (!(colourIndex >= 0) || !variants.length) return [];
      var seen = [];
      variants.forEach(function (v) {
        var c = v.options && v.options[colourIndex];
        if (c && seen.indexOf(c) < 0) seen.push(c);
      });
      return seen;
    }
    function buildMap() {
      var m = {};
      var cur = null, lead = [];
      orderedMedia().forEach(function (el) {
        if (el.dataset.mediaColour) cur = el.dataset.mediaColour;
        var id = el.dataset.mediaId;
        if (cur) { m[id] = [cur]; }
        else { m[id] = []; lead.push(id); }
      });
      /* A colour whose variants carry no featured media leaves its run untagged at the head
         of the list. If exactly one colour came out with nothing, that head run is plainly
         its group; anything less certain is left shared. */
      if (lead.length) {
        var claimed = [];
        Object.keys(m).forEach(function (k) {
          var c = m[k][0];
          if (c && claimed.indexOf(c) < 0) claimed.push(c);
        });
        var missing = colourList().filter(function (c) { return claimed.indexOf(c) < 0; });
        if (missing.length === 1) {
          lead.forEach(function (id) { m[id] = [missing[0]]; });
        }
      }
      return m;
    }
    function currentColour() {
      var input = root.querySelector('.ps-pdp__option--colour input:checked');
      return input ? input.value : null;
    }
    function colourCount() { return colourList().length; }
    var groupedColour = null;
    function applyGrouping(force) {
      if (!groupOn || !mediaEls.length || !(colourIndex >= 0)) return;
      var colour = currentColour();
      if (!colour) return;
      /* only the colour regroups the gallery — a size change must leave the shopper
         where they were scrolled to */
      if (!force && colour === groupedColour) return;
      groupedColour = colour;
      var map = buildMap();
      var tagged = 0, matched = 0, shared = 0;
      mediaEls.forEach(function (el) {
        var cols = map[el.dataset.mediaId];
        if (cols && cols.length) {
          tagged++;
          if (cols.indexOf(colour) >= 0) matched++;
        } else {
          shared++;
        }
      });
      /* nothing assigned anywhere → the feature is inert and every image shows.
         colour has no images of its own → fall back to the shared ones, and only if
         there are none of those either, show everything rather than an empty gallery. */
      var mode = 'group';
      if (!tagged) mode = 'all';
      else if (!matched) mode = shared ? 'sharedOnly' : 'all';

      mediaEls.forEach(function (el) {
        var cols = map[el.dataset.mediaId] || [];
        var isShared = !cols.length;
        var show;
        if (mode === 'all') show = true;
        else if (mode === 'sharedOnly') show = isShared;
        else if (isShared) show = sharedMode === 'after';
        else show = cols.indexOf(colour) >= 0;
        el.hidden = !show;
        var pushLast = isShared && mode === 'group' && sharedMode === 'after';
        el.classList.toggle('is-shared-media', pushLast);
        var dot = root.querySelector('.ps-pdp__dot[data-dot-for="' + el.dataset.mediaId + '"]');
        if (dot) {
          dot.hidden = !show;
          dot.classList.toggle('is-shared-media', pushLast);
        }
      });
      var firstDot = [].slice.call(dots).filter(function (d) { return !d.hidden; })[0];
      dots.forEach(function (d) { d.classList.toggle('is-active', d === firstDot); });
      if (track && track.scrollLeft) track.scrollLeft = 0;
    }
    applyGrouping();

    /* ---------- qty ---------- */
    var qty = root.querySelector('[data-ps-qty-input]');
    var minus = root.querySelector('[data-ps-qty-minus]');
    var plus = root.querySelector('[data-ps-qty-plus]');
    if (qty) {
      if (minus) minus.addEventListener('click', function () { qty.value = Math.max(1, (parseInt(qty.value) || 1) - 1); });
      if (plus) plus.addEventListener('click', function () { qty.value = (parseInt(qty.value) || 1) + 1; });
      qty.addEventListener('change', function () { if (!qty.value || qty.value < 1) qty.value = 1; });
    }

    /* ---------- buy now ---------- */
    if (buyNow) buyNow.addEventListener('click', function () {
      var id = idInput ? idInput.value : null; if (!id) return;
      var q = qty ? (parseInt(qty.value) || 1) : 1;
      /* carry any line item properties the form holds, and respect the market root */
      var form = root.querySelector('form[action*="/cart/add"], product-form form');
      var fd = form ? new FormData(form) : new FormData();
      fd.set('id', id); fd.set('quantity', q);
      buyNow.disabled = true;
      fetch((window.routes && window.routes.cart_add_url) || '/cart/add', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status) { showError(res.description || res.message); buyNow.disabled = false; }
          else { 



fetch("/browsing_context_suggestions.json")
  .then(response => response.json())
  .then(data => {
    const country = data?.detected_values?.country_name;

    switch (country) {
      case "India":
        if (
          window.gokwikSdk &&
          typeof window.gokwikSdk.initCheckout === "function"
        ) {
          window.gokwikSdk.initCheckout(merchantInfo);
        } else {
          console.error("GoKwik SDK not ready");
        }
        break;

      default:
        window.location.href =
          ((window.Shopify && Shopify.routes && Shopify.routes.root) || "/") +
          "checkout";
        break;
    }
  })
  .catch(error => {
    console.error("Error detecting country:", error);
  });


            // window.location.href = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'checkout'; 
            
            buyNow.disabled = false;
          }
        })
        .catch(function () { buyNow.disabled = false; showError('Could not start checkout — try again.'); });
    });
    var errorEl = root.querySelector('[data-ps-error]');
    function showError(msg) { if (!errorEl) return; errorEl.textContent = msg; errorEl.hidden = !msg; }
    root.__psShowError = showError;
    if (!window.__psCartErrorBound) {
      window.__psCartErrorBound = true;
      document.addEventListener('cart:error', function (e) {
        if (!e.detail) return;
        var target = document.querySelector('[data-section-id="' + e.detail.source + '"]') ||
                     document.querySelector('[data-ps-product]');
        if (target && target.__psShowError) target.__psShowError(e.detail.errors || e.detail.message);
      });
    }

    /* ---------- tabs ---------- */
    var switching = false;
    root.querySelectorAll('[data-ps-tab]').forEach(function (tab) {
      tab.addEventListener('click', function () {
        var i = tab.dataset.psTab;
        if (tab.classList.contains('is-active') || switching) return;
        switching = true;
        root.querySelectorAll('[data-ps-tab]').forEach(function (t) { var on = t.dataset.psTab === i; t.classList.toggle('is-active', on); t.setAttribute('aria-selected', on ? 'true' : 'false'); });
        var current = root.querySelector('[data-ps-panel].is-active');
        var next = root.querySelector('[data-ps-panel="' + i + '"]');
        var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        var show = function () {
          if (current) { current.classList.remove('is-active', 'is-leaving'); current.hidden = true; }
          if (next) {
            next.classList.add('is-entering'); next.hidden = false; next.classList.add('is-active');
            void next.offsetWidth; // reflow so the transition runs
            next.classList.remove('is-entering');
          }
          switching = false;
        };
        if (reduce || !current) { show(); return; }
        current.classList.add('is-leaving');
        setTimeout(show, 200);
      });
    });

    /* The size-guide drawer now lives in an inline script in ps-main-product.liquid.
       ps-product.js is deferred, so binding here meant the very first click landed
       before the handler existed and the link navigated to the page instead. */
    /* Desktop help pill: plain position:fixed while the gallery is still running (the
       compositor handles it, so no scroll jitter), then a single switch to an absolutely
       positioned park at the foot of the gallery. Nothing is repositioned per frame. */
    var helpPill = root.querySelector('[data-ps-help-float]');
    var helpGallery = root.querySelector('.ps-pdp__gallery');
    if (helpPill && helpGallery) {
      var helpGap = 0;
      var helpTick = false;
      var helpInfo = root.querySelector('.ps-pdp__info');
      /* Two-column (>=1100px): park at the foot of the gallery, as in the design.
         Stacked (tablet): the gallery ends halfway up the page, so park at the foot
         of the whole product block instead — otherwise the pill disappears early. */
      var helpAnchor = helpGallery;
      var pickAnchor = function () {
        var sideBySide = helpInfo && Math.abs(helpInfo.offsetTop - helpGallery.offsetTop) < 4;
        helpAnchor = sideBySide ? helpGallery : root;
      };
      var readHelpGap = function () {
        var wasParked = helpPill.classList.contains('is-parked');
        if (wasParked) helpPill.classList.remove('is-parked');
        helpGap = parseFloat(getComputedStyle(helpPill).bottom) || 24;
        if (wasParked) helpPill.classList.add('is-parked');
      };
      var placeHelp = function () {
        helpTick = false;
        if (getComputedStyle(helpPill).display === 'none') return;
        var g = helpAnchor.getBoundingClientRect();
        var park = g.bottom <= window.innerHeight - helpGap;
        if (park) {
          /* park level with the foot of the gallery, measured against the section */
          var top = Math.round(g.bottom - root.getBoundingClientRect().top - helpPill.offsetHeight);
          if (helpPill.dataset.parkTop !== String(top)) {
            helpPill.style.top = top + 'px';
            helpPill.dataset.parkTop = String(top);
          }
        } else if (helpPill.dataset.parkTop) {
          helpPill.style.top = '';
          delete helpPill.dataset.parkTop;
        }
        helpPill.classList.toggle('is-parked', park);
      };
      var queueHelp = function () { if (!helpTick) { helpTick = true; requestAnimationFrame(placeHelp); } };
      window.addEventListener('scroll', queueHelp, { passive: true });
      var refreshHelp = function () { readHelpGap(); pickAnchor(); queueHelp(); };
      window.addEventListener('resize', refreshHelp);
      window.addEventListener('orientationchange', refreshHelp);
      if (window.ResizeObserver) { try { new ResizeObserver(refreshHelp).observe(root); } catch (e) {} }
      window.addEventListener('load', refreshHelp);
      refreshHelp();
      placeHelp();
    }

    root.querySelectorAll('[data-ps-open-concierge]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var trigger = document.querySelector('[data-concierge-open]');
        if (trigger) { e.preventDefault(); trigger.click(); }
      });
    });

    /* ---------- recently viewed ---------- */
    try {
      var KEY = 'ps_recent', list = JSON.parse(localStorage.getItem(KEY) || '[]');
      var h = root.dataset.productHandle;
      list = list.filter(function (x) { return x !== h; }); list.unshift(h);
      localStorage.setItem(KEY, JSON.stringify(list.slice(0, 12)));
    } catch (e) {}
  }

  function boot() { document.querySelectorAll('[data-ps-product]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
